import { useEffect, useState } from 'react';
import { supabase } from '../../supabase';

export default function Metrics() {
  console.log('[Metrics.jsx] mounted');
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      const now = new Date();
      const dayAgo = new Date(now - 24*60*60*1000).toISOString();
      const weekAgo = new Date(now - 7*24*60*60*1000).toISOString();

      const [
        totalUsers, completedUsers, verifiedUsers, bannedUsers,
        usersToday, usersThisWeek,
        totalConnections, acceptedConnections,
        totalMessages,
        openReports, totalReports,
        pendingSelfies,
      ] = await Promise.all([
        supabase.from('profiles').select('id', { count: 'exact', head: true }),
        supabase.from('profiles').select('id', { count: 'exact', head: true }).eq('onboarding_complete', true),
        supabase.from('profiles').select('id', { count: 'exact', head: true }).eq('verified', true),
        supabase.from('profiles').select('id', { count: 'exact', head: true }).eq('banned', true),
        supabase.from('profiles').select('id', { count: 'exact', head: true }).gte('created_at', dayAgo),
        supabase.from('profiles').select('id', { count: 'exact', head: true }).gte('created_at', weekAgo),
        supabase.from('connections').select('id', { count: 'exact', head: true }),
        supabase.from('connections').select('id', { count: 'exact', head: true }).eq('status', 'accepted'),
        supabase.from('messages').select('id', { count: 'exact', head: true }),
        supabase.from('reports').select('id', { count: 'exact', head: true }).eq('status', 'open'),
        supabase.from('reports').select('id', { count: 'exact', head: true }),
        supabase.from('profiles').select('id', { count: 'exact', head: true })
          .not('selfie_url', 'is', null).eq('verified', false).is('verified_at', null),
      ]);

      setStats({
        totalUsers: totalUsers.count,
        completedUsers: completedUsers.count,
        verifiedUsers: verifiedUsers.count,
        bannedUsers: bannedUsers.count,
        usersToday: usersToday.count,
        usersThisWeek: usersThisWeek.count,
        totalConnections: totalConnections.count,
        acceptedConnections: acceptedConnections.count,
        totalMessages: totalMessages.count,
        openReports: openReports.count,
        totalReports: totalReports.count,
        pendingSelfies: pendingSelfies.count,
      });
    })();
  }, []);

  if (!stats) return <p style={{ color: '#888' }}>Loading…</p>;

  return (
    <div>
      <h1 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 24px 0' }}>Metrics</h1>

      <Section title="Users">
        <Card label="Total signups" value={stats.totalUsers} />
        <Card label="Completed onboarding" value={stats.completedUsers} />
        <Card label="Verified" value={stats.verifiedUsers} highlight={stats.pendingSelfies > 0 ? null : 'green'} />
        <Card label="Banned" value={stats.bannedUsers} highlight={stats.bannedUsers > 0 ? 'red' : null} />
      </Section>

      <Section title="Growth">
        <Card label="Signups today" value={stats.usersToday} />
        <Card label="Signups this week" value={stats.usersThisWeek} />
      </Section>

      <Section title="Activity">
        <Card label="Connection requests" value={stats.totalConnections} />
        <Card label="Accepted connections" value={stats.acceptedConnections} />
        <Card label="Messages sent" value={stats.totalMessages} />
      </Section>

      <Section title="Moderation queue">
        <Card label="Pending selfies" value={stats.pendingSelfies} highlight={stats.pendingSelfies > 0 ? 'yellow' : null} />
        <Card label="Open reports" value={stats.openReports} highlight={stats.openReports > 0 ? 'yellow' : null} />
        <Card label="Reports lifetime" value={stats.totalReports} />
      </Section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 32 }}>
      <h3 style={{ fontSize: 11, color: '#888', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 12 }}>{title}</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>{children}</div>
    </div>
  );
}

function Card({ label, value, highlight }) {
  const colors = {
    red: '#f87171', yellow: '#fbbf24', green: '#34d399', null: '#fff', undefined: '#fff',
  };
  return (
    <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 12, padding: 20 }}>
      <div style={{ fontSize: 11, color: '#888', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>{label}</div>
      <div style={{ fontSize: 32, fontWeight: 900, color: colors[highlight], letterSpacing: -1 }}>{value ?? '—'}</div>
    </div>
  );
}
